import React, { useEffect } from "react";
import { IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const SnackBarAlert = (props) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={Boolean(props.open)}
      autoHideDuration={5000}
      onClose={props.handleClose}
      message={props.open}
      ContentProps={{
        sx: {
          position: "relative",
          paddingRight: "40px", // space for button
          alignItems: "flex-start", // top align
        },
      }}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={props.handleClose}
            sx={{
            position: "absolute",
            top: 6,
            right: 6,
          }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    />
  );
};
